import { Controller } from "stimulus";

export default class extends Controller {
  static values = { key: String };

  connect() {
    if (!this.hasKeyValue || !window.$) return;

    const saved = localStorage.getItem(this.storageKey());
    if (saved) {
      const target = this.element.querySelector(`[data-toggle="tab"][href="${saved}"]`);
      if (target) {
        window.$(target).tab("show");
      }
    }

    this.$boundOnShown = (event) => {
      const href = event.target && event.target.getAttribute("href");
      if (href) {
        localStorage.setItem(this.storageKey(), href);
      }
    };
    window.$(this.element).on("shown.bs.tab", this.$boundOnShown);
  }

  disconnect() {
    if (this.$boundOnShown && window.$) {
      window.$(this.element).off("shown.bs.tab", this.$boundOnShown);
    }
  }

  storageKey() {
    return `persistent-tabs:${this.keyValue}`;
  }
}
